import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ParametersService } from '../../components/parameters/parameters.service';
import { map, Observable } from 'rxjs';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush, // performanter weil nur noch Objektreferenzen verglichen werden
    // ACHTUNG: wird ein Objekt verändert, dann wird diese Änderung von Angular nicht mehr erkannt wegen der DetectionStrategy!
    standalone: false
})
export class FooterComponent {


    private readonly homepageLayers: readonly string[] = [
        'de_be', 'fr_be', 'nl_be', 'cs_cz',
        'da_dk', 'de_de', 'es_es', 'fr_fr',
        'en_ie', 'it_it', 'nl_nl', 'de_at',
        'pl_pl', 'de_ch', 'fr_ch', 'sk_sk',
        'fi_fi', 'en_uk', 'sv_se', 'ru_ru',
        'uk_ua', 'en_us', 'en_ca', 'fr_ca',
        'es_zs', 'en_au', 'en_nz', 'de_in',
        'en_in', 'fr_in', 'ru_in'] as const;
    anio: number = new Date().getFullYear();
    countryCode$: Observable<string>;

    constructor(
        private readonly parametersService: ParametersService
    ) {
        this.countryCode$ = this.parametersService.getParametersObservable()
            .pipe(
                map(param => param.country?.code?.toLowerCase()),
                map(country => this.homepageLayers.includes(country) ? country : 'en_in')
            );
    }

    openCookieSettings(): void {
        const ucCmp = (globalThis as { __ucCmp?: { showSecondLayer: () => void } }).__ucCmp;
        ucCmp?.showSecondLayer();
    }

}

